import emailjs from '@emailjs/browser';

// Wrapper d'envoi d'email (auto-reply) via EmailJS
// Nécessite variables d'environnement (publiques côté client) :
// REACT_APP_EMAILJS_PUBLIC_KEY, REACT_APP_EMAILJS_SERVICE_ID, REACT_APP_EMAILJS_TEMPLATE_ID
// ATTENTION: Ne JAMAIS exposer la private key dans le front. Utiliser uniquement la public key.

const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;

if (!PUBLIC_KEY || !SERVICE_ID || !TEMPLATE_ID) {
  // Simple warning (non bloquant) pour dev
  // eslint-disable-next-line no-console
  console.warn('[EmailJS] Variables manquantes: PUBLIC_KEY/SERVICE_ID/TEMPLATE_ID');
}

emailjs.init(PUBLIC_KEY || '');

/**
 * Envoie un e-mail auto-réponse après soumission du formulaire.
 * @param {Object} payload - Données du formulaire.
 * @returns {Promise<void>}
 */
export async function sendBriefEmail(payload) {
  if (!PUBLIC_KEY || !SERVICE_ID || !TEMPLATE_ID) return; // Silencieux si non configuré

  // Mapping des champs pour EmailJS
  // IMPORTANT: 'email' = destinataire (client), les autres champs sont pour personnaliser le contenu
  const templateParams = {
    // Informations du client (destinataire de l'auto-reply)
    name: payload.nom_contact || payload.entreprise || 'Client',
    email: payload.email, // DESTINATAIRE - email du client qui recevra l'auto-reply
    phone: payload.telephone || '-',
    
    // Contenu du message
    subject: `Demande de projet - ${payload.types_projet?.[0] || 'Projet'}`,
    message: buildMessageExcerpt(payload),
    // Champs pricing (nouvel export)
    pricing_total: payload.pricing_total || payload.price_estimate?.totalPrice || '',
    pricing_base: payload.pricing_base || payload.price_estimate?.basePrice || '',
    pricing_includes: payload.pricing_includes || (payload.price_estimate?.includes||[]).join('\n• '),
    pricing_adjustments: payload.pricing_adjustments || (payload.price_estimate?.adjustments||[]).map(a=>{
      const amount = typeof a.amount === 'number' ? `${a.amount}€` : a.amount; return `• ${amount} ${a.label}`;
    }).join('\n'),
    pricing_rounding_note: payload.pricing_rounding_note || payload.price_estimate?.roundingNote || '' ,
  };

  // Injection de tous les champs form_* si présents dans le payload
  Object.keys(payload).forEach(k => {
    if(/^form_/.test(k)) templateParams[k] = payload[k];
  });

  try {
    await emailjs.send(SERVICE_ID, TEMPLATE_ID, templateParams);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('[EmailJS] Echec envoi auto-reply:', err?.message || err || 'Erreur inconnue');
  }
}

function buildMessageExcerpt(d){
  const lignes = [];
  if (d.fonctionnalites?.length) lignes.push('Fonctionnalités: ' + d.fonctionnalites.join(', '));
  if (d.description) lignes.push('Description: ' + (d.description.slice(0,180)) + (d.description.length>180?'...':''));
  return lignes.join('\n');
}
